import {
  Component,
  DestroyRef,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  Router,
  RouterOutlet,
} from '@angular/router';
import { FuseSplashScreenService } from '@fuse/services/splash-screen';
import { EnvironmentBannerComponent } from 'app/core/components/environment-banner/environment-banner.component';
import { filter, take } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [EnvironmentBannerComponent, RouterOutlet],
})
export class AppComponent {
  private _router = inject(Router);
  private _splashScreenService = inject(FuseSplashScreenService);
  private _destroyRef = inject(DestroyRef);

  /**
   * Constructor
   */
  constructor() {
    // `FuseSplashScreenService` only hides the splash screen on the first
    // `NavigationEnd`. A navigation that errors or is cancelled — an unmatched
    // URL, a throwing resolver, a guard rejection — never emits one, so the
    // splash screen would spin forever with no way out. Hide it on any settled
    // navigation as a safety net; the router surfaces the failure separately.
    this._router.events
      .pipe(
        filter(
          (event: Event) =>
            event instanceof NavigationEnd ||
            event instanceof NavigationCancel ||
            event instanceof NavigationError,
        ),
        take(1),
        takeUntilDestroyed(this._destroyRef),
      )
      .subscribe(() => this._splashScreenService.hide());
  }
}
